.dda-home-banner {
  width: 100%;
  height: calc(100vh);
  background-color: black;
  position: relative;
  overflow: hidden;
  display: block;
}

.dda-home-banner .dda-home-slides .dda-home-banner-slide::before {
  content: '';
  width: 100%;
  height: 80%;
  position: absolute;
  bottom: 0;
  background: rgb(0, 0, 0);
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 100%);
  z-index: 1;
}

.dda-home-slides {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  /* transition: all 0.7s ease-in-out; */
}

.dda-home-banner .dda-home-slides img,
.dda-home-banner .dda-home-slides video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
}

.dda-home-banner .dda-home-slides .dda-home-banner-slide {
  position: relative;
  width: 100vw;
  height: 100vh;
}

.dda-home-banner .dda-home-slides .dda-home-banner-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  opacity: 0;
  /* transition: opacity 1s ease-in-out; */
  pointer-events: none;
  z-index: 0;
  box-sizing: border-box;
}

.dda-home-banner .dda-home-slides .dda-home-banner-slide.active {
  opacity: 1;
  pointer-events: auto;
  z-index: 1;
}

.dda-home-banner-slider-nav {
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 279px;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 5px;
  height: 30px;
  z-index: 3;
}

.dda-home-banner-slider-nav .dda-home-banner-slider-nav-content{
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.dda-home-banner-slider-nav .dda-home-banner-prev,
.dda-home-banner-slider-nav .dda-home-banner-next,
.dda-home-banner-slider-nav .dda-home-banner-Pause {
  height: 28px;
  width: 28px;
  padding: 0;
  margin: 0;
  border: 0;
  background: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: rgba(0, 0, 0, 0);
  border-radius: 50%;
  font-size: 25px;
  /* transition: all 0.2s linear; */
}
.dda-home-banner-slider-nav .dda-home-banner-prev:hover,
.dda-home-banner-slider-nav .dda-home-banner-next:hover {
  background: rgba(0, 0, 0, 0.15);
}

.dda-home-banner-slider-nav .dda-home-banner-Pause span{
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.dda-home-banner-slider-nav .dda-home-banner-Pause span svg.main-circle{
  width: 30px;
  height: 30px;
}
.dda-home-banner-slider-nav .dda-home-banner-Pause span svg.nav-play-icon{
  width: 10px;
  height: 10px;
  position: absolute;
  top: 9px;
  left: 9px;
}
.dda-home-banner-slider-nav .dda-home-banner-Pause span svg.nav-pause-icon{
  width: 9px;
  height: 9px;
  position: absolute;
  top: 9px;
  left: 9px;
}
.dda-home-banner-slider-nav ul {
  display: flex;
  align-items: center;
  gap: 15px;
}

.dda-home-banner-slider-nav .dots {
  display: block;
  width: 10px;
  height: 10px;
  background: rgba(256,256,256,0.2);
  overflow: hidden;
  text-indent: -100px;
  margin: 0;
  padding: 0;
  border: 0px;
  border-radius: 20px;
  cursor: pointer;
  /* transition: all 0.2s linear; */
}

.dda-home-banner-slider-nav .dots.active {
  background: rgba(256,256,256,0.85);
}




/* .dda-slider-timer-circle {
  transition: stroke-dashoffset 3s linear;
} */


[dir="rtl"] .dda-home-banner-slider-nav .dda-home-banner-next i.material-icons {
  transform: rotate(180deg);
}

[dir="rtl"] .dda-home-banner-slider-nav .dda-home-banner-prev i.material-icons {
  transform: rotate(-180deg);
}




/*Customizable slider content based on entity design*/
.dda-home-banner .dda-slide-contant-wrap {
  position: relative;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
}

.dda-home-banner .dda-slide-contant {
  width: 90vw;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

.dda-home-banner .dda-slide-contant h2 {
  font-size: var(--dda-fs-display-sm);
  color: #fff;
  font-weight: var(--dda-fw-700);
}

.dda-home-banner .dda-slide-contant p {
  font-size: var(--dda-fs-headline-sm);
  color: #fff;
  font-weight: var(--dda-fw-300);
}



.material-symbols-outlined {
  font-variation-settings:
  'FILL' 1,
  'wght' 400,
  'GRAD' 0,
  'opsz' 24
}


@media screen and (max-width:992px) {
  
}
@media (max-width: 1024px) {
  .dda-home-banner {
    height: calc(100vh);
  }
  .dda-home-banner .dda-slide-contant {
        width: 100vw;
    }
  .dda-home-banner-slider-nav {
    bottom: 300px;
  }
  .dda-mouse-scroll,
  .dda-home-banner-prev,
  .dda-home-banner-Pause,
  .dda-home-banner-next{
    display: none !important;
  }
  .dda-home-banner .dda-slide-contant-wrap{
      display: inherit;
      height: auto;
      position: absolute;
      bottom: 350px;
    }
    
}


@media (prefers-reduced-motion: no-preference) {
  .dda-home-slides {
    transition: all 0.7s ease-in-out;
  }
  .dda-home-banner .dda-home-slides .dda-home-banner-slide {
    transition: opacity 1s ease-in-out;
  }
  .dda-home-banner-slider-nav .dda-home-banner-prev,
  .dda-home-banner-slider-nav .dda-home-banner-next,
  .dda-home-banner-slider-nav .dda-home-banner-Pause {
    transition: all 0.2s linear;
  }
  .dda-home-banner-slider-nav .dots {
    transition: all 0.2s linear;
  }
  .dda-slider-timer-circle {
    transition: stroke-dashoffset 3s linear;
  }

}